import * as actions from '../actions/actionTypes';

const initialState = {
  data: [],
  logo: [],
}

const fetchEmployerSuccess = (state, action) => {
  return { ...state, data: action.data }
}

const updateSuccess = (state, action) => {
    return { ...state,
       data: action.data,
      
      }
}

const getLogo64Success = (state, action) => {
  const newData = state.data;
  newData.logoBase64 = action.logo;
  return { ...state, data: newData }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_EMPLOYER_SUCCESS: return fetchEmployerSuccess(state, action);
    case actions.UPDATE_EMPLOYER_SUCCESS: return updateSuccess(state, action);
    case actions.GET_EMPLOYER_LOGO_SUCCESS: return getLogo64Success(state, action);
    default: return state;
  }
}

export default reducer;